export default {
  label: "Configuración",
};
